export default "__VITE_ASSET__BdATD86R__"